import React, { useState } from "react";
import LockIcon from "../../common/images-new/lock-gray-icon.svg"
import { Card } from "../../pages/Theme";
import Toggle from "../Button/Toggle";
import GoogleApiWrapper from "./MapGoogle";
// import MapGoogle from "./MapGoogle";
import { Link } from "react-router-dom/cjs/react-router-dom";

const Map = () => {
    const [show, setShow] = useState(true)
    return(
            <Card className={`${show === true ? 'block' : 'hidden'} 
                    flex flex-col bg-white w-screen relative absolute md:top-0 md:rounded-lg `}
            >
                <div className="md:mt-4 mb-4 flex flex-row px-3 items-center justify-center md:justify-between">
                    <div className="flex flex-row">
                        <p className="text-base font-bold">My Map</p>
                    </div>
                </div>
                <Link to={"/map"}>
                <div className="flex justify-center cursor-pointer">
                    {/* <MapGoogle /> */}
                    <GoogleApiWrapper/>
                </div>  
                </Link>         
            </Card>
    )
} 

export default Map;
